module.exports = __webpack_public_path__ + "img/ufms_logo.3785f13c.webp";